import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { CompetenceStatuses, ElearningStatuses } from 'types/card'
import { createApiAction } from 'api'
import { getDictionaries } from 'core/dictionaries/api/dictionariesService'
import { namespace as elearningDetailsNamespace } from 'modules/activityDetails/ElearningDetails/localization'
import { ElearningType } from 'modules/activityDetails/ElearningDetails/types'
import { namespace as quickGuideDetailsNamespace } from 'modules/activityDetails/QuickGuideDetails/localization'
import { namespace as videoDetailsNamespace } from 'modules/activityDetails/VideoDetails/localization'
import { DictionariesState, ApiDictionariesnResponse } from './types'

const I18_PATH_ELEARNING_DETAILS = `${elearningDetailsNamespace}:elearningDetails`
const I18_PATH_VIDEO_DETAILS = `${videoDetailsNamespace}:videoDetails`
const I18_PATH_QUICK_GUIDE_DETAILS = `${quickGuideDetailsNamespace}:quickGuideDetails`

export const DICTIONARIES = {
  elearningStatuses: [
    { id: ElearningStatuses.NotStarted, name: 'dictionaries.elearningStatuses.notStarted' },
    { id: ElearningStatuses.InProgress, name: 'dictionaries.elearningStatuses.inProgress' },
    { id: ElearningStatuses.Completed, name: 'dictionaries.elearningStatuses.completed' },
  ],
  internalElearningStatuses: [
    { id: undefined, name: 'dictionaries.elearningStatuses.notStarted' },
    { id: 0, name: 'dictionaries.elearningStatuses.inProgress' },
    { id: 1, name: 'dictionaries.elearningStatuses.completed' },
  ],
  requirementStatuses: [
    { id: CompetenceStatuses.Approved, name: 'dictionaries.requirementStatuses.approved' },
    { id: CompetenceStatuses.Disapproved, name: 'dictionaries.requirementStatuses.disapproved' },
    { id: CompetenceStatuses.NotYetApproved, name: 'dictionaries.requirementStatuses.notApproved' },
  ],
  yesNo: [
    { id: 'false', name: 'dictionaries.yesNo.no' },
    { id: 'true', name: 'dictionaries.yesNo.yes' },
  ],
  elearningType: [
    { id: ElearningType.Elearning, name: `${I18_PATH_ELEARNING_DETAILS}.title` },
    { id: ElearningType.QuickGuide, name: `${I18_PATH_QUICK_GUIDE_DETAILS}.title` },
    { id: ElearningType.Video, name: `${I18_PATH_VIDEO_DETAILS}.title` },
  ],
  availabilities: [{ id: 'true', name: 'dictionaries.availability.available' }],
}

const initialState: DictionariesState = {
  dictionariesData: {},
}

const dictionariesSlice = createSlice({
  name: 'dictionaries',
  initialState,
  reducers: {
    dictionariesLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiDictionariesnResponse>>
    ) {
      state.dictionariesData = action.payload
      state.dictionariesData.result = {
        dictionaries: { ...DICTIONARIES, ...action.payload.result?.dictionaries },
      }
    },
  },
})

const { dictionariesLoaded } = dictionariesSlice.actions
export default dictionariesSlice.reducer

export const loadDictionariesData = () => {
  return createApiAction({
    apiCalls: {
      dictionaries: getDictionaries,
    },
    payloadAction: dictionariesLoaded,
    enableErrorNotification: true,
    shouldCallApi: ({ dictionaries }) => !dictionaries.dictionariesData.isLoading,
  })
}
